<template>
  <div v-clickOutside="close" class="relative flex">
    <ButtonModule
      ref="reference"
      prefix="text-20 icon-sync opacity-50"
      class="transform rotate-90"
      @click="toggle"
    />

    <div
      v-show="isDropdownVisible"
      class="rounded-4 shadow-dropdown z-50 absolute"
      :style="`top: 30px; ${position}; width: 150px`"
    >
      <div class="rounded-4" :class="isDarkMode ? 'bg-sidebar' : 'bg-white'" @click="close">
        <div class="px-12 py-10 relative text-app-color">
          <p class="font-bold text-15">Recurring item</p>
          <p v-if="recurringBy && !isEdit" class="text-14">
            {{ recurringBy }}
          </p>
          <RecurringMenu
            v-if="isEdit"
            v-model="period"
            :values="periods"
            :update-immediately="isNewEvent"
            @deleteRecurring="deleteRecurring"
            @updateRecurring="updateRecurring"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import RecurringMenu from '@/components/week-planner/RecurringMenu'

import { useStore } from 'vuex'
import { computed, ref, defineComponent } from 'vue'

export default defineComponent({
  components: {
    ButtonModule,
    RecurringMenu
  },

  props: {
    periodType: String,
    periodValue: Number,
    isNewEvent: Boolean,
    isEdit: Boolean
  },

  emits: ['addRecurring', 'deleteRecurring', 'updateRecurring'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)

    const isDropdownVisible = ref(false)
    const reference = ref(null)

    const position = ref(0)

    const period = computed({
      get: () => {
        return {
          type: props.periodType,
          value: props.periodValue
        }
      },
      set: val => {
        emit('addRecurring', val)
      }
    })

    const periods = [
      { label: 'weekly', value: { type: 'week', value: 1 } },
      { label: 'bi-weekly', value: { type: 'week', value: 2 } },
      { label: 'monthly', value: { type: 'month', value: 1 } },
      { label: 'yearly', value: { type: 'year', value: 1 } }
    ]

    const recurringBy = computed(() => {
      if (!props.periodType || !props.periodValue) return null
      const period = periods.find(({ value }) => value.type === props.periodType && value.value === props.periodValue)

      return period.label
    })

    function deleteRecurring (value) {
      emit('deleteRecurring', value)
    }

    function updateRecurring ({ period, value }) {
      emit('updateRecurring', { period, value })
    }

    const confirm = (value) => {
      deleteRecurring(value)
    }

    function toggle () {
      isDropdownVisible.value = !isDropdownVisible.value

      if (isDropdownVisible.value) {
        setPosition()
      }
    }

    function setPosition () {
      const rect = reference.value.$el.getBoundingClientRect()
      const modalWidth = 150
      const gap = 20

      if (rect.left - modalWidth > gap) {
        position.value = 'right: 0px'
      } else {
        position.value = 'left: 0px'
      }
    }

    function close () {
      isDropdownVisible.value = false
    }

    return {
      periods,
      isDropdownVisible,
      position,
      // computeds
      isDarkMode,
      period,
      recurringBy,
      // refs
      reference,
      // functions
      deleteRecurring,
      confirm,
      updateRecurring,
      toggle,
      close
    }
  }
})
</script>
